
import { Component, Vue } from 'vue-property-decorator'
import Changelog from '@/components/modals/changelog.vue'

// Simple legal + handy links footer bit
// Sorta stolen from Etro
@Component
export default class Footer extends Vue {
  get currentYear(): number {
    return (new Date()).getFullYear()
  }

  get baseUrl(): string {
    return process.env.VUE_APP_URL
  }

  showChangelog(): void {
    this.$modal.show(Changelog)
  }
}
